import styles from './PoleRessourcesHumaines.module.css'
import {
  SvgOfficialLogoMetropole,
  SvgOfficialLogoVille,
} from '../../../svg/SvgComponents'

const PoleRessourcesHumaines = () => (
  <>
    <header className={styles.header}>
      <div className={styles.bluePart}>
        <span className={styles.poleText}>POLE</span>
      </div>
      <div className={styles.whitePart}>
        <span className={styles.rhText}>RESSOURCES HUMAINES</span>
      </div>
      <div className={styles.logoFrame}>
        <div className={styles.logoFrameInner}>
          <SvgOfficialLogoMetropole color="#009BA4" />
          <SvgOfficialLogoVille color="#009BA4" />
        </div>
      </div>
    </header>
  </>
)

export default PoleRessourcesHumaines
